module.exports = __webpack_public_path__ + "static/media/tab.7ed5b08c.png";